import React from "react";
import { Link } from "gatsby";
import Layout from "../components/base/blog-layout";
import SEO from "../components/base/seo";
import blogPosts from "../dataset/blog-posts";
import "../styles/pages/_blog.scss";

const Blog = () => {
  return (
    <Layout>
      <SEO
        title="Marketing Insights | Blog"
        description="Read Marketing Related Insights, Ideas, and Interesting Tidbits from The Simple Department."
      />
      <section className="page-heading">
        <div className="container">
          <h1>Marketing Minutes</h1>
        </div>
      </section>
      <section>
        <div className="container all-blogs">
          {blogPosts.map((post, i) => (
            <div key={i} className="single-blog-wrapper">
              <Link className="single-blog-inner" to={post.path}>
                <img
                  src={post.featuredImage}
                  alt={post.title}
                />
                <p className="single-blog-short-info">
                  {post.categories?.join(", ")}
                </p>
                <p className="single-blog-title">{post.title}</p>
                <p className="single-blog-excert">{post.excerpt}</p>
                <span className="blue-arrow-btn">READ MORE</span>
              </Link>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default Blog;
